var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"pick-button",class:[_vm.isActive ? 'active' : 'normal'],on:{"click":_vm.onClick}},[_c('p',[_vm._v(_vm._s(_vm.value))]),_c('img',{attrs:{"src":_vm.iconSRC}})])
}
var staticRenderFns = []

export { render, staticRenderFns }